namespace $.$$ {
	export class $horrorgamelanding_app extends $.$horrorgamelanding_app {
		@$mol_mem
		email(next?: string) {
			return next ?? ''
		}

		@$mol_mem
		Subscribe() {
			return new this.$.$horrorgamelanding_subscribe()
		}
	}
}
